<template>
  <div class="fx_chart_bar_container" :ref="ref">
    <!-- <span @click="toEdite()" class="option">编辑</span> -->
    <div class="fx_chart_title" v-if="title" :style="titleStyle">
      {{title}}
      <slot></slot>
    </div>
    <div :style="{'height':`${chartHeight}`}">
      <div class="fx_chart_bar" :ref="chartRef"></div>
    </div>
    <!-- <div class="editor" v-if="showEditor">
      <textarea class="ivu-input" autocomplete="off" v-model="optioForEdite"></textarea>
    </div> -->
  </div>
</template>
<script>
import autoResize from "../../../src/mixins/autoResize";

import { deepClone } from "@jiaminghi/c-render/lib/plugin/util";

import Echarts from "echarts";

export default {
  name: "fxChartBar",
  mixins: [autoResize],
  data() {
    const timestamp = Date.now();
    let defaultOption = {
      backgroundColor: "transparent", // 透明背景色
      // color: [_this.themaColor],
      tooltip: {},
      xAxis: {
        data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
      },
      yAxis: {},
      series: [
        {
          name: "销量",
          type: "bar",
          data: [5, 20, 36, 10, 10, 20],
          label: {
            normal: {
              textStyle: {
                // color: _this.themaColor // 从data里获取与主题相关的字体颜色
                color: "blue"
              }
            }
          }
        }
      ]
    };
    return {
      title: "",
      titleStyle: "",
      chartHeight: "100%",
      ref: `charts-bar-container-${timestamp}`,
      chartRef: `echart-bar-${timestamp}`,
      echart: null,
      option: {},
      showEditor: false,
      defaultOption:defaultOption
      // themaColor: this.$store.state.core.themaColor.basetextcolor //从vuex里获取基本文字颜色
    };
  },
  props: {
    config: {
      type: Object,
      default() {
        return {
          option: this.defaultOption
        };
      }
    }
  },
  computed: {
    optioForEdite() {
      let obj = deepClone(this.option, true);
      return obj;
    }
  },
  watch: {
    "config.option": {
      handler(newVal, oldVal) {
        let { echart, option } = this;
        if (!echart) return;
        // if (!option) option = {};

        option = Object.assign(this.defaultOption, newVal);
        echart.setOption(option, true);
      }
      // deep: true
    }
  },
  methods: {
    initEchart() {
      //初始化echarts实例
      const { $refs, chartRef, option } = this;
      const echart = (this.echart = Echarts.init($refs[chartRef]));
      if (!option) return;

      echart.setOption(option);
    },
    afterAutoResizeMixinInit() {
      const { initEchart } = this;
      initEchart();
    },
    onResize() {
      // 自适应
      const { echart } = this;
      if (!echart) return;
      echart.resize();
    },
    getChart() {
      let { echart } = this;
      return echart;
    },

    toEdite() {
      this.showEditor = !this.showEditor;
    }
  },

  mounted() {
    let { title, titleStyle, option } = this.config;
    if (title) {
      this.title = title;
    }
    if (titleStyle) {
      this.titleStyle = titleStyle;
    }
    if (option) {
      this.option = option;
    }

    if (titleStyle && titleStyle.height) {
      this.chartHeight = `calc( 100% - ${titleStyle.height})`;
    }

    this.$nextTick(() => {
      this.initEchart();
    });
  }
};
</script>
<style lang="scss" scoped>
.fx_chart_bar_container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // position: relative;
  .fx_chart_title {
    color: #000;
    font-size: 16px;
    text-align: left;
    height: 40px;
    line-height: 40px;
  }
  .fx_chart_bar {
    width: 100%;
    height: 100%;
  }
  // .option {
  //   position: absolute;
  //   right: 0;
  //   top: 0;
  //   z-index: 1;
  // }
  // .editor {
  //   width: 400px;
  //   height: 500px;
  //   background: red;
  //   position: absolute;
  //   right: -420px;
  //   top: 0;
  // }
}
</style>